module.exports = __webpack_public_path__ + "img/icons.a144d829.svg";